import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Radio from '../../common/Radio';
import RadioGroup from '../../common/RadioGroup';
import Select from '../../common/Select';
import SlideCard from '../../common/SlideCard';
import styles from './InvoiceField.module.scss';
import { DISABLED, ENABLED } from '../../../constants/permissions';

const invoiceOptions = [
  { label: 'Immediate', value: '0' },
  { label: 'Net 30', value: '30' },
  { label: 'Net 45', value: '45' },
  { label: 'Net 60', value: '60' },
];

export function InvoiceField(props) {
  const { type, onChange } = props;

  const [enabled, setEnabled] = useState(props.sendInvoice);
  const [paymentTerms, setPaymentTerms] = useState(props.invoiceNetPlus);

  useEffect(() => {
    onChange(enabled, paymentTerms);
  }, [onChange, enabled, paymentTerms]);

  return (
    <SlideCard title="Automatic invoicing" description={enabled ? 'Enabled' : 'Disabled'} testId={`${type}-invoice`}>
      <RadioGroup
        name={`${type}SendInvoice`}
        onChange={(value) => setEnabled(value === 'enabled')}
        selectedvalue={enabled ? 'enabled' : 'disabled'}
      >
        <Radio id={`${type}_invoice_true`} value={ENABLED} label="Enabled" />
        <Radio id={`${type}_invoice_false`} value={DISABLED} label="Disabled" />
      </RadioGroup>

      <div className={styles.paymentTerms}>
        <label>Payment Terms:</label>
        <span>
          <Select
            options={invoiceOptions}
            disabled={!enabled}
            value={paymentTerms.toString()}
            onChange={setPaymentTerms}
          />
        </span>
      </div>
    </SlideCard>
  );
}

InvoiceField.propTypes = {
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sendInvoice: PropTypes.bool.isRequired,
  invoiceNetPlus: PropTypes.number.isRequired,
  isImmediate: PropTypes.bool,
};
